import React from 'react'
import GoogleIcon from '../../icon/GoogleIcon'

const IndicatorItem = ({ title, icon, iconClass, text }) => (
  <div
    className="assign-document-indicator-subtitles"
    title={title}
  >
    <GoogleIcon
      name={icon}
      className={iconClass}
      size={22}
    />
    <span className="assign-document-indicator-text">
      {text}
    </span>
  </div>
)

export default IndicatorItem
